import dayjs from 'dayjs';

import type { IExtraLocaleType } from 'src/interfaces';

const locales: Record<IExtraLocaleType, () => Promise<ILocale>> = {
  he: () => import('dayjs/locale/he'),
};

export const loadExtraLocale = (locale: IExtraLocaleType) => {
  if (locale) {
    locales[locale]?.().then(() => dayjs.locale(locale));
  }
};
